export const NavigationTrackingType = Object.freeze({
  LOGO: 'Logo',
  SEARCH: 'Search',
  LIKED_PRODUCTS: 'Liked products',
  LOGIN: 'Login',
  CART: 'Cart',
  STORES: 'Stores',
});
